var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"config-input-row"},[_c('span',{staticClass:"config-input-icon"},[_vm._t("config_hang_input_img")],2),_c('div',{staticClass:"config-input-field"},[_vm._t("config_hang_input_left")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }